import { Vector3 } from 'three';
import { resolveConnectorContourPaths, resolveItemFlag } from '@toolproof-core/visualization/rendering/_pure/frame-bounds';
import type { Vector3Tuple } from '@toolproof-core/visualization/_contract/geometry';
import type { SpaceDerivationFrame } from '@toolproof-core/visualization/derivation/_contract/derivation';
import type { WorkflowFeatureTarget } from './_contract/episode';

export function teachingFeaturePaths(frame: SpaceDerivationFrame, target: WorkflowFeatureTarget, fixedDirection?: Vector3Tuple): Vector3Tuple[][] {
    if (target.targetKind === 'connector') return resolveConnectorContourPaths(frame, target.itemKey);
    const item = frame.itemCollections.flatMap(collection => collection.itemCollectionKind === 'entity' ? collection.items : [])
        .find(item => item.itemKey === target.itemKey);
    if (!item) throw new Error(`Teaching target '${target.itemKey}' is absent.`);
    const flag = resolveItemFlag(frame, item.itemKey);
    if (!flag) throw new Error(`Teaching target '${target.itemKey}' has no flag.`);
    const up = new Vector3(...flag.postOffset).negate().normalize();
    const direction = new Vector3(...flag.attachment).negate();
    direction.y = 0.28 * Math.hypot(direction.x, direction.z);
    if (direction.lengthSq() < 1e-9) direction.set(0, 0.28, 1);
    if (fixedDirection) direction.set(...fixedDirection);
    const right = new Vector3().crossVectors(up, direction).normalize();
    const points = [[0, -0.5], [1, -0.5], [1, 0.5], [0, 0.5], [0, -0.5]];
    return [points.map(([x, y]) => new Vector3(...flag.attachment)
        .addScaledVector(right, x! * flag.width).addScaledVector(up, y! * flag.height).toArray())];
}
